import { useMemo } from 'react';

import type { CheckoutSessionsResponse } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';
import {
  getSycurioTelephonicEntryDetails,
  getSessionId,
  getMerchantId,
  getAgent,
  getPaymentMethodId,
  getCustomerId,
} from '../../../utils/session/selectors';
import { generateTrackEventMetadata } from '../utilities/generateTrackEventMetadata';

export const useSycurioPhoneEntrySubmitSessionDetails = ({
  sessionResponse,
}: {
  sessionResponse: CheckoutSessionsResponse;
}) => {
  const telephonicEntryDetails = useMemo(
    () => getSycurioTelephonicEntryDetails(sessionResponse),
    [
      sessionResponse.checkoutSession.telephonicEntryDetails
        ?.status,
    ],
  );

  const checkoutSessionId = useMemo(
    () => getSessionId(sessionResponse),
    [sessionResponse.checkoutSession.id],
  );
  const merchantId = useMemo(
    () => getMerchantId(sessionResponse),
    [sessionResponse.checkoutSession.vendorMerchantId],
  );

  const agent = useMemo(
    () => getAgent(sessionResponse),
    [
      sessionResponse.checkoutSession.checkoutRequest.agent
        ?.userId,
    ],
  );

  const sycurioMetadata = generateTrackEventMetadata({
    name: 'attachPaymentMethod',
    sycurioMetadataArgs: {
      sycurioFragmentUrl:
        telephonicEntryDetails && 'url' in telephonicEntryDetails
          ? telephonicEntryDetails.url
          : '',
      checkoutSessionId,
      merchantId,
    },
    paymentMethod: {
      paymentMethodId: getPaymentMethodId(sessionResponse) ?? '',
      customerId: getCustomerId(sessionResponse) ?? '',
      agentId: agent?.userId ?? '',
    },
  });

  return {
    telephonicEntryDetails,
    checkoutSessionId,
    merchantId,
    agent,
    sycurioMetadata,
  };
};
